export default "__VITE_ASSET__BdhiG2$y__"